<template>
  <div>
    <DiffHeader :mbB="value.before" :mbA="value.after" class="mb-6" />
    <DiffTable :cols="cols" :pairs="pairs" :mbB="value.before" :mbA="value.after" />
  </div>
</template>

<script>
import DiffTable from './DiffTable.vue'
import DiffHeader from './DiffHeader.vue'
import { isTech, missingOne } from './compare-utils.js'

export default {
  components: { DiffTable, DiffHeader },
  props: {
    // value: {
    //   clientId: number
    //   vehicleCode: string
    //   before: { drivers: [] }
    //   after: { drivers: [] },
    //   pairs: []
    // }
    //
    // onde cada driver é:
    // driver: {
    //   id, code, role, group, name, expiresAt,
    //   driverCreatedAt, driverUpdatedAt,
    //   cardAssociatedAt
    // }
    value: { required: true },
    showAll: { type: Boolean, default: false },
    hideTechs: { type: Boolean, default: false }
  },
  data() {
    return {
      cols: [
        { label: 'ID', prop: 'id' },
        { label: 'Name', prop: 'name' },
        { label: 'Crachá', prop: 'code' },
        { label: 'Role', prop: 'role' },
        { label: 'Expira', prop: 'expiresAt' }
      ]
    }
  },
  computed: {
    pairs() {
      return this.value.pairs.filter((pair) => {
        if ( this.hideTechs ) {
          if ( pair.a != null && isTech(pair.a) ) return false
          if ( pair.b != null && isTech(pair.b) ) return false
        }
        if (this.showAll) return true
        return missingOne(pair)
      })
    }
  }
}
</script>

<style></style>
